<template>
  <div>
    <el-form-item label="服务城市：">
      <div v-if="form.waiter.sign">{{form.waiter.sign.city}}</div>
    </el-form-item>
    <el-form-item label="服务半径：">
      <div v-if="form.waiter.sign">{{form.waiter.sign.scope?form.waiter.sign.scope:0}}km</div>
    </el-form-item>
    <el-form-item label="当前签到地址：">
      <div v-if="form.waiter.sign">{{form.waiter.sign.newAddress}}</div>
    </el-form-item>
    <el-form-item label="签到经纬度：">
      <div v-if="form.waiter.sign">{{form.waiter.sign.newLng}},{{form.waiter.sign.newLat}}</div>
    </el-form-item>
    <el-form-item label="签到时间：">
      <div v-if="form.waiter.sign">{{form.waiter.sign.updateTime}}</div>
    </el-form-item>

  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  inject: ["form"],
  mounted() {},
  computed: {},
  methods: {}
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/technician/technicianlist/part/servicearea.vue